import SortUtils from "../../SortUtils";


export default class CardUtils extends SortUtils {
  
  static SortByCreatedDate = function(a, b) {
    return SortUtils.SortBy("createdDate", a, b);
  }
  
  static SortByName = function(a,b) {
    return SortUtils.SortBy("prompt", a, b);
  }

  static SortByNameDesc = function(a,b) {
    return SortUtils.SortByDesc("prompt", a, b);
  }
}